



import Check from "rutas/check";

import Laboratorio from "views/diagnostico/diagnostico/laboratorio.js";
import MSDK from "views/maps/m-sdk";
import Icons from "views/Icons";
import ReportesLaboratorio from "views/diagnostico/reportes/reportes_LABORATORIO";
import Ficha from "views/diagnostico/ficha";

var RoutesLaboratorio = [


  {
    path: "/laboratorio",
    name: "LABORATORIO",
    icon: " tim-icons  icon-single-02",
    component: <Laboratorio />,
    layout: "/laboratorio-diagnostico",
  },

  {
    path: "/fichas",
    name: "FICHA",
    icon: " tim-icons  icon-badge",
    component: <Ficha />,
    layout: "/laboratorio-diagnostico",
  },
  {
    path: "/reportes-diagnostico",
    name: "REPORTES DX",
    icon: " tim-icons  icon-heart-2",
    component: <ReportesLaboratorio />,
    layout: "/laboratorio-diagnostico",
    // redirect
  },
  {
    path: "/georef",
    name: "Georeferenciaciones",
    icon: "tim-icons icon-pin",
    componet: <Check component={MSDK} />,
    layout: "/laboratorio-diagnostico",
  },

  // {
  //   path: "/icons",
  //   name: "icons",
  //   icon: "tim-icons icon-pin",
  //   component: <Icons />,
  //   layout: "/laboratorio-diagnostico",
  // },



];
export default RoutesLaboratorio;
